import { useEffect } from 'react'
import { AdasPaper } from '@components/wrapper-components'
import Iframe from 'react-iframe'
import { useLoadingStore } from '@caradasstore/LoadingStore'
export const HealthCheckPage = () => {
  const setLoading = useLoadingStore((store) => store.setLoading)
  useEffect(() => {
    setLoading(true)

    const timeoutId = setTimeout(() => {
      setLoading(false)
      console.error('Iframe load timed out')
    }, 15000)

    return () => clearTimeout(timeoutId)
  }, [setLoading])
  return (
    <div className='mx-auto max-w-[1400px] py-6'>
      <AdasPaper elevation={0} className='h-screen p-5 mt-5'>
        <Iframe
          url='https://health.caradasplus.com/'
          position='static'
          width='100%'
          id='myId'
          className='myClassname'
          height='100%'
          onLoad={() => setLoading(false)}
        />
      </AdasPaper>
    </div>
  )
}
